import { Box, Typography, styled } from "@mui/material";
import AlertLoading from "../navigation/AlertLoading";

const ContainerBox = styled(Box)(({palette}) => {
    return ({
        display: 'inline-flex',
    })
})

const ChipBox = styled(Box)(({palette}) => {
    return ({
        color: palette.contrastText,
        background: palette.main,
        padding: '0.5em 1.0em',
        borderRadius: '1.2em',
        border: `1px solid ${palette.contrastText}`,
        fontSize: '0.8em',
    })
})

export function StatusChip({status, statusReason, chipPalette, ...props}) {
    return (
        <>
        {
            !status
            ?
            <AlertLoading spinner={true} inline />
            :
            <ContainerBox {...props}>
                <Box sx={{display: 'inline-block', textAlign: 'center'}}>
                    <ChipBox palette={chipPalette} >{status}</ChipBox>
                    {
                        statusReason
                        &&
                        <Typography variant="body2"><strong>{statusReason}</strong></Typography>
                    }
                </Box>
            </ContainerBox>
        }
        </>
    )
}